import React, { useContext } from "react";
import BusinessContext from "context/BusinessContext";

const ModalPoint = () => {
  const { product } = useContext(BusinessContext);
  return (
    <div
      className="modal fade"
      id="ModalPoint"
      tabIndex="-1"
      aria-labelledby="ModalPointLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="ModalPointLabel">
              طرح هدیه
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div>
              امتیاز دریافتی پس از به اشتراک گذاری محصول :{" "}
              <span>{product.sharePoint}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ModalPoint;
